<template>
  <AppLayout>
    <VFlex>
      <h1 class="primary--text mb-4">
        {{ $nt('heading') }}
      </h1>
      <VCard>
        <VTabs color="white">
          <VTab
            v-for="item in accountSettings"
            :key="item.name"
            :to="{name: item.routeName}"
          >
            {{ item.name }}
          </VTab>
        </VTabs>
        <VDivider />
        <VFlex>
          <RouterView />
        </VFlex>
      </VCard>
    </VFlex>
  </AppLayout>
</template>

<script>
export default {
  name: 'Settings',
  computed: {
    accountSettings () {
      return [
        { name: this.$nt('personalInfo'), routeName: 'personalInfoSettings' },
        { name: this.$nt('email'), routeName: 'emailSettings' },
        { name: this.$nt('password'), routeName: 'passwordSettings' },
        { name: this.$nt('gdpr'), routeName: 'gdprSettings' }
      ]
    }
  }
}
</script>